/**
 * Wrapper for owl.lazyload that fixes the loader for hidden images
 */

import $ from 'jquery';

import 'owl.carousel/src/js/owl.carousel';
import 'owl.carousel/src/js/owl.lazyload';

const origLazyLoad = $.fn.owlCarousel.Constructor.Plugins.Lazy.prototype.load;
$.fn.owlCarousel.Constructor.Plugins.Lazy.prototype.load = function load(position) {
    const $item = this._core.$stage.children().eq(position);
    const $elements = $item.find('.owl-lazy');

    // Set HTML native "loading='lazy'" if the image is hidden to prevent the browser from actually loading it.
    // Remove "loading" otherwise, so the browser effectively (pre)loads the current(/next/previous) image(s).
    if (!$item.is(':visible')) {
        $elements.attr('loading', 'lazy');
    } else {
        $elements.not(':visible').attr('loading', 'lazy');
        $elements.filter(':visible').removeAttr('loading');
    }

    // Call the original owl.lazyload
    origLazyLoad.call(this, position);
};
